// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Users, ListOrdered, TrendingUp, History, Plus, Eye, Pencil, Trash2 } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Tabs from '../../../components/Tabs/Tabs';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { toIsoDate } from '../../../utils/dateFormat';
// import { getEmployeeList } from '../../../action/Employee';
// import { getDesignationList } from '../../../action/Designation';
// import { savePayrollEntity } from '../../../action/Payroll';
// import AssignEmployeeSalaryDialog from '../../../components/EmployeeSalary/AssignEmployeeSalaryDialog';
// import AddEmployeeSalaryComponentDialog from '../../../components/EmployeeSalary/AddEmployeeSalaryComponentDialog';
// import EmployeeSalaryDialog from '../../../components/EmployeeSalary/EmployeeSalaryDialog';
// import { toast } from 'react-toastify';
// import useToast from '../../../utils/useToast';
// import Toast from '../../../components/Toast/Toast';
// import { useConfirm } from '../../../utils/ConfirmContext';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;
// const ICON = { size: 15 };

// /* Every table on this page shares these. */
// const TABLE_PROPS = {
//   search: true,
//   searchLabel: 'Search',
//   pageSize: 10,
//   scrollClassName: '',
// };

// const statusColumn = {
//   key: 'status',
//   label: 'Status',
//   align: 'center',
//   render: (r) => <StatusPill label={r.status} />,
// };

// /* ── Employee Salary ─────────────────────────────────────────────────────── */
// /*
// const EmployeeSalaryTab = () => {
//   const dispatch = useDispatch();

//   const [open, setOpen] = useState(false);
//   const [dialogMode, setDialogMode] = useState('add');
//   const [selectedSalary,setSelectedSalary] = useState(null);

//   const employees = useSelector((state) => state.employee.list);
//   const designations = useSelector((state) => state.designation.list);

//   const { list, loading } = usePayrollEntity('employeeSalary');
//   const { list: periods } = usePayrollEntity('payrollPeriods');

//   useEffect(() => {
//     dispatch(getEmployeeList()).catch(() => {});
//     dispatch(getDesignationList()).catch(() => {});
//   }, [dispatch]);

//   const employeeMap = employees.reduce((map, emp) => {
//     map[emp.HED_SERVICE_NO] = emp;
//     return map;
//   }, {});

//   const designationMap = designations.reduce((map, designation) => {
//     map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
//     return map;
//   }, {});

//   const handleAdd = () => {
//     setSelectedSalary(null);
//     setDialogMode('add');
//     setOpen(true);
//   }

//   const handleView = (record) => {
//     setSelectedSalary(record);
//     setDialogMode('view');
//     setOpen(true);
//   }

//   const handleEdit = (record) => {
//     setSelectedSalary(record);
//     setDialogMode('edit');
//     setOpen(true);
//   }

//   const handleSave = async (form) => {
//     await dispatch(savePayrollEntity('employeeSalary', form, dialogMode === 'edit'));
//     setOpen(false);
//     setSelectedSalary(null);
//     setDialogMode('add');
//   };

//   const handleClose = () => {
//     setOpen(false);
//   }

//   const handleDialogExited = () => {
//     setSelectedSalary(null);
//     setDialogMode('add');
//   }

//   const handleDelete = async (record) => {
//     const confirmed = window.confirm(
//       `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`
//     );

//     if (!confirmed) {
//       return;
//     }

//     try {
//       await dispatch(
//         savePayrollEntity(
//           'employeeSalary',
//           {
//             id: record.id,
//             isActive: false,
//           },
//           true
//         )
//       );

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode('add');
//     } catch (err) {
//       console.error('Failed to delte employee salary: ', err);
//     }
//   }

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Employee Salary"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={['empNo', 'name', 'department']}
//         searchPlaceholder="Search by employee name or number..."
//         emptyMessage="No salary records found"
//         onAdd={{ label: 'Assign Salary', icon: <Plus {...ICON} />, onClick: handleAdd }}
//         columns={[
//           { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
//           {
//             key: 'designation',
//             label: 'Designation',
//             className: 'text-gray-600',
//             render: (r) => {
//               const emp = employeeMap[r.empNo];
//               return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
//             },
//           },
//           { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
//           // { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.basic) },
//           { key: 'workingDays', label: 'Working Days', align: 'right', className: 'text-gray-600' },
//           // { key: 'workingHours', label: 'Working Hours', align: 'right', className: 'text-gray-600' },
//           { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
//           { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'effectiveEndDate', label: 'Effective End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           statusColumn,
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             render: (r) => (
//               <div className="flex items-center justify-center gap-2">
//                 <button
//                   type="button"
//                   onClick={() => handleView(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="View"
//                 >
//                   <Eye size={16} /> 
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleEdit(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="Update"
//                 >
//                   <Pencil size={16} />
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleDelete(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-red-50
//                     hover:text-red-600
//                     transition-colors
//                   "
//                   title="Delete"
//                 >
//                   <Trash2 size={16} />
//                 </button>
//               </div>
//             ),
//           },
//         ]}
//       />

//       <AssignEmployeeSalaryDialog
//         open={open}
//         onClose={handleClose}
//         onExited={handleDialogExited}
//         onSave={handleSave}
//         employees={employees}
//         payrollPeriods={periods}
//         employeeSalaries={list}
//         mode={dialogMode}
//         salary={selectedSalary}
//       />
//     </>
//   );
// };
// */

// /* ── Salary Components ───────────────────────────────────────────────────── */
// /*
// const SalaryComponentsTab = () => {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(getEmployeeList());
//   }, [dispatch]);

//   const { list, loading } = usePayrollEntity('employeeSalaryComponents');
//   const { list: components } = usePayrollEntity('payrollComponents');
//   const { list: employeeSalaries } = usePayrollEntity('employeeSalary');

//   const [open, setOpen] = useState(false);
//   const [employeeSalaryId, setEmployeeSalaryId] = useState('');

//   const filtered = list
//     .filter((x) => String(x.employeeSalaryId) === String(employeeSalaryId))
//     .map((x) => ({
//       ...x,
//       componentName: components.find((c) => c.id === x.componentId)?.name ?? x.remarks,
//     }));

//   const handleSave = async (form) => {
//     await dispatch(savePayrollEntity('employeeSalaryComponents', form));
//     setOpen(false);
//   };

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         search={false}
//         title="Salary Components"
//         loading={loading}
//         rows={filtered}
//         rowKey="id"
//         emptyMessage="Please select an employee to view records."
//         onAdd={{
//           label: 'Assign Component',
//           icon: <Plus {...ICON} />,
//           onClick: () => {
//             if (!employeeSalaryId) return;
//             setOpen(true);
//           },
//         }}
//         toolbarExtra={
//           <div className="w-[320px] max-w-full">
//             <span className={LABEL}>Employee</span>
//             <select
//               value={employeeSalaryId}
//               onChange={(e) => setEmployeeSalaryId(e.target.value)}
//               className={`${FIELD} w-full`}
//             >
//               <option value="">Select Employee</option>
//               {employeeSalaries.map((salary) => (
//                 <option key={salary.id} value={salary.id}>
//                   {salary.empNo} - {salary.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         }
//         columns={[
//           { key: 'componentName', label: 'Component', grow: true, className: 'font-semibold text-gray-900' },
//           { key: 'amount', label: 'Amount (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.amount) },
//           { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'endDate', label: 'End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           {
//             key: 'status',
//             label: 'Status',
//             align: 'center',
//             render: (r) => <StatusPill label={r.isActive ? 'Active' : 'Inactive'} />,
//           },
//         ]}
//       />

//       <AddEmployeeSalaryComponentDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         employeeSalaryId={employeeSalaryId}
//         payrollComponents={components}
//       />
//     </>
//   );
// };
// /*

// /* ── Salary Revision ─────────────────────────────────────────────────────── */
// /*
// const SalaryRevisionTab = () => {
//   const { list, loading } = usePayrollEntity('salaryRevision');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Salary Revision"
//       loading={loading}
//       rows={list}
//       rowKey="id"
//       searchKeys={['empNo', 'name']}
//       searchPlaceholder="Search salary revisions..."
//       emptyMessage="No salary revisions found"
//       onAdd={{ label: 'New Revision', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
//         { key: 'oldBasic', label: 'Old Basic (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.oldBasic) },
//         { key: 'newBasic', label: 'New Basic (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.newBasic) },
//         { key: 'increasePct', label: 'Increase', align: 'right', className: 'text-emerald-700 font-semibold' },
//         { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//         { key: 'reason', label: 'Reason', className: 'text-gray-600' },
//         statusColumn,
//       ]}
//     />
//   );
// };
// /*

// /* ── Increment History ───────────────────────────────────────────────────── */
// /*
// const IncrementHistoryTab = () => {
//   const { list, loading } = usePayrollEntity('incrementHistory');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Increment History"
//       loading={loading}
//       rows={list}
//       rowKey="id"
//       searchKeys={['empNo', 'name', 'cycle']}
//       searchPlaceholder="Search increment history..."
//       emptyMessage="No increment history found"
//       columns={[
//         { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
//         { key: 'cycle', label: 'Review Cycle', className: 'text-gray-600' },
//         { key: 'oldBasic', label: 'Previous Basic (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.oldBasic) },
//         { key: 'newBasic', label: 'New Basic (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.newBasic) },
//         { key: 'increasePct', label: 'Increase', align: 'right', className: 'text-emerald-700 font-semibold' },
//         { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//       ]}
//     />
//   );
// };
// /*

// /* ── Page ────────────────────────────────────────────────────────────────── */
// /*
// const PayrollEmployeeSalary = () => {
//   const tabs = [
//     { key: 'salary', label: 'Employee Salary', icon: <Users {...ICON} />, content: <EmployeeSalaryTab /> },
//     { key: 'components', label: 'Salary Components', icon: <ListOrdered {...ICON} />, content: <SalaryComponentsTab /> },
//     // { key: 'revision', label: 'Salary Revision', icon: <TrendingUp {...ICON} />, content: <SalaryRevisionTab /> },
//     // { key: 'history', label: 'Increment History', icon: <History {...ICON} />, content: <IncrementHistoryTab /> },
//   ];

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={['Payroll', 'Employee Salary']}
//         title="Employee Salary"
//         subtitle="Assign, revise and track individual employee salary records."
//       />
//       <Tabs tabs={tabs} defaultTab="salary" />
//     </div>
//   );
// };

// export default PayrollEmployeeSalary;
// */

// const PayrollEmployeeSalary = () => {
//   const dispatch = useDispatch();
//   const confirm = useConfirm();

//   const [open, setOpen] = useState(false);
//   const [dialogMode, setDialogMode] = useState("add");
//   const [selectedSalary, setSelectedSalary] = useState(null);

//   const employees = useSelector((state) => state.employee.list);
//   const designations = useSelector((state) => state.designation.list);

//   const employeeMap = employees.reduce((map, emp) => {
//     map[emp.HED_SERVICE_NO] = emp;
//     return map;
//   }, {});

//   const designationMap = designations.reduce((map, designation) => {
//     map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
//     return map;
//   }, {});

//   const { list, loading } = usePayrollEntity("employeeSalary");
//   const { list: components } = usePayrollEntity("employeeSalaryComponents");
//   const { list: payrollComponents } = usePayrollEntity("payrollComponents");

//   const { toast, showToast, hideToast } = useToast();

//   useEffect(() => {
//     dispatch(getEmployeeList()).catch(() => {});
//     dispatch(getDesignationList()).catch(() => {});
//   }, [dispatch]);

//   const handleAdd = () => {
//     setSelectedSalary(null);
//     setDialogMode("add");
//     setOpen(true);
//   };

//   const handleView = (record) => {
//     setSelectedSalary(record);
//     setDialogMode("view");
//     setOpen(true);
//   };

//   const handleEdit = (record) => {
//     setSelectedSalary(record);
//     setDialogMode("edit");
//     setOpen(true);
//   };

//   const handleSave = async (form, pendingComponents = []) => {
//     try {
//       const isEdit = dialogMode === "edit";

//       // Save employee salary and get the employeeSalaryId
//       const employeeSalaryId = await dispatch(
//         savePayrollEntity(
//           "employeeSalary",
//           form,
//           isEdit
//         )
//       );

//       // For the new salary, save each salary component
//       if (pendingComponents.length > 0) {
//         await Promise.all(
//           pendingComponents.map((component) => {
//             dispatch(
//               savePayrollEntity(
//                 "employeeSalaryComponents",
//                 {
//                   employeeSalaryId,
//                   componentId: component.componentId,
//                   amount: component.amount,
//                   percentage: component.percentage,
//                   effectiveDate: component.effectiveDate,
//                   endDate: component.endDate,
//                   isActive: component.isActive,
//                   remarks: component.remarks,
//                 },
//                 false
//               )
//             )
//           })
//         )
//       }

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode("add");

//       showToast(isEdit ? "Employee salary updated successfully." : "Employee salary saved successfully.", "success");

//     } catch (error) {
//       console.error("Failed to save employee salary: ", error);

//       showToast(
//         error?.response?.data?.message ||
//         error?.response?.data?.Message ||
//         error?.message ||
//         "Failed to save employee salary.",
//         'error'
//       );
//     }
//   };

//   const handleUpdateComponent = async (component) => {
//     try {
//       await dispatch(
//         savePayrollEntity(
//           "employeeSalaryComponents",
//           component,
//           true
//         )
//       );

//       showToast("Salary component updated successfully.", "success");
//     } catch (error) {
//       console.error("Failed to update salary component: ", error);
//       showToast(
//         error?.response?.data?.Message ||
//         error?.response?.data?.message || 
//         error?.message || 
//         "Failed to update salary component.",
//         "error"
//       )

//       throw error;
//     }
//   }

//   const handleDelete = async (record) => {
//     const confirmed = await confirm({
//       title: "Delete this salary?",
//       message: `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`,
//       confirmLabel: "Delete",
//       cancelLabel: "Cancel",
//     })

//     if (!confirmed) {
//       return;
//     }

//     try {
//       await dispatch(
//         savePayrollEntity(
//           'employeeSalary',
//           {
//             id: record.id,
//             isActive: false,
//           },
//           true
//         )
//       );

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode('add');
//     } catch (err) {
//       console.error('Failed to delte employee salary: ', err);
//     }
//   }

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={["Payroll", "Employee Salary"]}
//         title="Employee Salary"
//         subtitle="Assign, revise and track individual employee salary records."
//       />

//       <Table
//         {...TABLE_PROPS}
//         title="Employee Salary"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={["empNo", "name", "department"]}
//         searchPlaceholder="Search by employee name or number..."
//         emptyMessage="No salary records found"
//         onAdd={{
//           label: "Assign Salary",
//           icon: <Plus {...ICON} />,
//           onClick: handleAdd,
//         }}
//         columns={[
//           { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
//           {
//             key: 'designation',
//             label: 'Designation',
//             className: 'text-gray-600',
//             render: (r) => {
//               const emp = employeeMap[r.empNo];
//               return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
//             },
//           },
//           { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
//           // { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.basic) },
//           { key: 'workingDays', label: 'Working Days', align: 'right', className: 'text-gray-600' },
//           // { key: 'workingHours', label: 'Working Hours', align: 'right', className: 'text-gray-600' },
//           { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
//           { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'effectiveEndDate', label: 'Effective End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           statusColumn,
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             render: (r) => (
//               <div className="flex items-center justify-center gap-2">
//                 <button
//                   type="button"
//                   onClick={() => handleView(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="View"
//                 >
//                   <Eye size={16} /> 
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleEdit(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="Update"
//                 >
//                   <Pencil size={16} />
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleDelete(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-red-50
//                     hover:text-red-600
//                     transition-colors
//                   "
//                   title="Delete"
//                 >
//                   <Trash2 size={16} />
//                 </button> 
//               </div>
//             ),
//           },
//         ]}
//       />

//       <EmployeeSalaryDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         onSaveComponent={handleUpdateComponent}
//         employees={employees}
//         employeeSalaries={list}
//         salary={selectedSalary}
//         mode={dialogMode}
//         salaryComponents={components}
//         payrollComponents={payrollComponents}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </div>
//   );
// };

// export default PayrollEmployeeSalary;



//------------------------------------------------------------------------------------------------

// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Users, ListOrdered, TrendingUp, History, Plus, Eye, Pencil, Trash2 } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Tabs from '../../../components/Tabs/Tabs';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { toIsoDate } from '../../../utils/dateFormat';
// import { fetchAllEmployees } from '../../../store/slices/employeeSlice';
// import { getDesignationList } from '../../../store/slices/designationSlice';
// import { savePayrollEntity } from '../../../store/slices/payrollSlice';
// import AssignEmployeeSalaryDialog from '../../../components/EmployeeSalary/AssignEmployeeSalaryDialog';
// import AddEmployeeSalaryComponentDialog from '../../../components/EmployeeSalary/AddEmployeeSalaryComponentDialog';
// import EmployeeSalaryDialog from '../../../components/EmployeeSalary/EmployeeSalaryDialog';
// import { toast } from 'react-toastify';
// import useToast from '../../../utils/useToast';
// import Toast from '../../../components/Toast/Toast';
// import { useConfirm } from '../../../utils/ConfirmContext';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;
// const ICON = { size: 15 };

// /* Every table on this page shares these. */
// const TABLE_PROPS = {
//   search: true,
//   searchLabel: 'Search',
//   pageSize: 10,
//   scrollClassName: '',
// };

// const statusColumn = {
//   key: 'status',
//   label: 'Status',
//   align: 'center',
//   render: (r) => <StatusPill label={r.status} />,
// };

/* ── Employee Salary ─────────────────────────────────────────────────────── */
/*
const EmployeeSalaryTab = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState('add');
  const [selectedSalary,setSelectedSalary] = useState(null);

  const employees = useSelector((state) => state.employees.employees);
  const designations = useSelector((state) => state.designationSlice.designations);

  const { list, loading } = usePayrollEntity('employeeSalary');
  const { list: periods } = usePayrollEntity('payrollPeriods');

  useEffect(() => {
    dispatch(fetchAllEmployees());
    dispatch(getDesignationList());
  }, [dispatch]);

  const employeeMap = employees.reduce((map, emp) => {
    map[emp.HED_SERVICE_NO] = emp;
    return map;
  }, {});

  const designationMap = designations.reduce((map, designation) => {
    map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
    return map;
  }, {});

  const handleAdd = () => {
    setSelectedSalary(null);
    setDialogMode('add');
    setOpen(true);
  }

  const handleView = (record) => {
    setSelectedSalary(record);
    setDialogMode('view');
    setOpen(true);
  }

  const handleEdit = (record) => {
    setSelectedSalary(record);
    setDialogMode('edit');
    setOpen(true);
  }

  const handleSave = async (form) => {
    await dispatch(savePayrollEntity('employeeSalary', form, dialogMode === 'edit'));
    setOpen(false);
    setSelectedSalary(null);
    setDialogMode('add');
  };

  const handleClose = () => {
    setOpen(false);
  }

  const handleDialogExited = () => {
    setSelectedSalary(null);
    setDialogMode('add');
  }

  const handleDelete = async (record) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`
    );

    if (!confirmed) {
      return;
    }

    try {
      await dispatch(
        savePayrollEntity(
          'employeeSalary',
          {
            id: record.id,
            isActive: false,
          },
          true
        )
      );

      setOpen(false);
      setSelectedSalary(null);
      setDialogMode('add');
    } catch (err) {
      console.error('Failed to delte employee salary: ', err);
    }
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Employee Salary"
        loading={loading}
        rows={list}
        rowKey="id"
        searchKeys={['empNo', 'name', 'department']}
        searchPlaceholder="Search by employee name or number..."
        emptyMessage="No salary records found"
        onAdd={{ label: 'Assign Salary', icon: <Plus {...ICON} />, onClick: handleAdd }}
        columns={[
          { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
          { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
          {
            key: 'designation',
            label: 'Designation',
            className: 'text-gray-600',
            render: (r) => {
              const emp = employeeMap[r.empNo];
              return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
            },
          },
          { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
          // { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.basic) },
          { key: 'workingDays', label: 'Working Days', align: 'right', className: 'text-gray-600' },
          // { key: 'workingHours', label: 'Working Hours', align: 'right', className: 'text-gray-600' },
          { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
          { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
          { key: 'effectiveEndDate', label: 'Effective End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            render: (r) => (
              <div className="flex items-center justify-center gap-2">
                <button
                  type="button"
                  onClick={() => handleView(r)}
                  className="
                    inline-flex h-8 w-8 items-center justify-center
                    rounded-md
                    text-gray-500
                    hover:bg-surface-100
                    hover:text-primary-600
                    transition-colors
                  "
                  title="View"
                >
                  <Eye size={16} /> 
                </button>

                <button
                  type="button"
                  onClick={() => handleEdit(r)}
                  className="
                    inline-flex h-8 w-8 items-center justify-center
                    rounded-md
                    text-gray-500
                    hover:bg-surface-100
                    hover:text-primary-600
                    transition-colors
                  "
                  title="Update"
                >
                  <Pencil size={16} />
                </button>

                <button
                  type="button"
                  onClick={() => handleDelete(r)}
                  className="
                    inline-flex h-8 w-8 items-center justify-center
                    rounded-md
                    text-gray-500
                    hover:bg-red-50
                    hover:text-red-600
                    transition-colors
                  "
                  title="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ),
          },
        ]}
      />

      <AssignEmployeeSalaryDialog
        open={open}
        onClose={handleClose}
        onExited={handleDialogExited}
        onSave={handleSave}
        employees={employees}
        payrollPeriods={periods}
        employeeSalaries={list}
        mode={dialogMode}
        salary={selectedSalary}
      />
    </>
  );
};
*/

/* ── Salary Components ───────────────────────────────────────────────────── */
/*
const SalaryComponentsTab = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  const { list, loading } = usePayrollEntity('employeeSalaryComponents');
  const { list: components } = usePayrollEntity('payrollComponents');
  const { list: employeeSalaries } = usePayrollEntity('employeeSalary');

  const [open, setOpen] = useState(false);
  const [employeeSalaryId, setEmployeeSalaryId] = useState('');

  const filtered = list
    .filter((x) => String(x.employeeSalaryId) === String(employeeSalaryId))
    .map((x) => ({
      ...x,
      componentName: components.find((c) => c.id === x.componentId)?.name ?? x.remarks,
    }));

  const handleSave = async (form) => {
    await dispatch(savePayrollEntity('employeeSalaryComponents', form));
    setOpen(false);
  };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        search={false}
        title="Salary Components"
        loading={loading}
        rows={filtered}
        rowKey="id"
        emptyMessage="Please select an employee to view records."
        onAdd={{
          label: 'Assign Component',
          icon: <Plus {...ICON} />,
          onClick: () => {
            if (!employeeSalaryId) return;
            setOpen(true);
          },
        }}
        toolbarExtra={
          <div className="w-[320px] max-w-full">
            <span className={LABEL}>Employee</span>
            <select
              value={employeeSalaryId}
              onChange={(e) => setEmployeeSalaryId(e.target.value)}
              className={`${FIELD} w-full`}
            >
              <option value="">Select Employee</option>
              {employeeSalaries.map((salary) => (
                <option key={salary.id} value={salary.id}>
                  {salary.empNo} - {salary.name}
                </option>
              ))}
            </select>
          </div>
        }
        columns={[
          { key: 'componentName', label: 'Component', grow: true, className: 'font-semibold text-gray-900' },
          { key: 'amount', label: 'Amount (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.amount) },
          { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
          { key: 'endDate', label: 'End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
          {
            key: 'status',
            label: 'Status',
            align: 'center',
            render: (r) => <StatusPill label={r.isActive ? 'Active' : 'Inactive'} />,
          },
        ]}
      />

      <AddEmployeeSalaryComponentDialog
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        employeeSalaryId={employeeSalaryId}
        payrollComponents={components}
      />
    </>
  );
};
/*

/* ── Salary Revision ─────────────────────────────────────────────────────── */
/*
const SalaryRevisionTab = () => {
  const { list, loading } = usePayrollEntity('salaryRevision');
  return (
    <Table
      {...TABLE_PROPS}
      title="Salary Revision"
      loading={loading}
      rows={list}
      rowKey="id"
      searchKeys={['empNo', 'name']}
      searchPlaceholder="Search salary revisions..."
      emptyMessage="No salary revisions found"
      onAdd={{ label: 'New Revision', icon: <Plus {...ICON} /> }}
      columns={[
        { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
        { key: 'oldBasic', label: 'Old Basic (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.oldBasic) },
        { key: 'newBasic', label: 'New Basic (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.newBasic) },
        { key: 'increasePct', label: 'Increase', align: 'right', className: 'text-emerald-700 font-semibold' },
        { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
        { key: 'reason', label: 'Reason', className: 'text-gray-600' },
        statusColumn,
      ]}
    />
  );
};
/*

/* ── Increment History ───────────────────────────────────────────────────── */
/*
const IncrementHistoryTab = () => {
  const { list, loading } = usePayrollEntity('incrementHistory');
  return (
    <Table
      {...TABLE_PROPS}
      title="Increment History"
      loading={loading}
      rows={list}
      rowKey="id"
      searchKeys={['empNo', 'name', 'cycle']}
      searchPlaceholder="Search increment history..."
      emptyMessage="No increment history found"
      columns={[
        { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
        { key: 'cycle', label: 'Review Cycle', className: 'text-gray-600' },
        { key: 'oldBasic', label: 'Previous Basic (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.oldBasic) },
        { key: 'newBasic', label: 'New Basic (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.newBasic) },
        { key: 'increasePct', label: 'Increase', align: 'right', className: 'text-emerald-700 font-semibold' },
        { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
      ]}
    />
  );
};
/*

/* ── Page ────────────────────────────────────────────────────────────────── */
/*
const PayrollEmployeeSalary = () => {
  const tabs = [
    { key: 'salary', label: 'Employee Salary', icon: <Users {...ICON} />, content: <EmployeeSalaryTab /> },
    { key: 'components', label: 'Salary Components', icon: <ListOrdered {...ICON} />, content: <SalaryComponentsTab /> },
    // { key: 'revision', label: 'Salary Revision', icon: <TrendingUp {...ICON} />, content: <SalaryRevisionTab /> },
    // { key: 'history', label: 'Increment History', icon: <History {...ICON} />, content: <IncrementHistoryTab /> },
  ];

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={['Payroll', 'Employee Salary']}
        title="Employee Salary"
        subtitle="Assign, revise and track individual employee salary records."
      />
      <Tabs tabs={tabs} defaultTab="salary" />
    </div>
  );
};

export default PayrollEmployeeSalary;
*/

// ----------------------------------------------------------------------------------------------------------------------------------------

// const PayrollEmployeeSalary = () => {
//   const dispatch = useDispatch();
//   const confirm = useConfirm();

//   const [open, setOpen] = useState(false);
//   const [dialogMode, setDialogMode] = useState("add");
//   const [selectedSalary, setSelectedSalary] = useState(null);

//   const employees = useSelector((state) => state.employees.employees);
//   const designations = useSelector((state) => state.designationSlice.designations);

//   const employeeMap = employees.reduce((map, emp) => {
//     map[emp.HED_SERVICE_NO] = emp;
//     return map;
//   }, {});

//   const designationMap = designations.reduce((map, designation) => {
//     map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
//     return map;
//   }, {});

//   const { list, loading } = usePayrollEntity("employeeSalary");
//   const { list: components } = usePayrollEntity("employeeSalaryComponents");
//   const { list: payrollComponents } = usePayrollEntity("payrollComponents");

//   const { toast, showToast, hideToast } = useToast();

//   useEffect(() => {
//     dispatch(fetchAllEmployees());
//     dispatch(getDesignationList());
//   }, [dispatch]);

//   const handleAdd = () => {
//     setSelectedSalary(null);
//     setDialogMode("add");
//     setOpen(true);
//   };

//   const handleView = (record) => {
//     setSelectedSalary(record);
//     setDialogMode("view");
//     setOpen(true);
//   };

//   const handleEdit = (record) => {
//     setSelectedSalary(record);
//     setDialogMode("edit");
//     setOpen(true);
//   };

//   const handleSave = async (form, pendingComponents = []) => {
//     try {
//       const isEdit = dialogMode === "edit";

//       // Save employee salary and get the employeeSalaryId
//       const employeeSalaryId = await dispatch(
//         savePayrollEntity(
//           "employeeSalary",
//           form,
//           isEdit
//         )
//       );

//       // For the new salary, save each salary component
//       if (pendingComponents.length > 0) {
//         await Promise.all(
//           pendingComponents.map((component) => {
//             dispatch(
//               savePayrollEntity(
//                 "employeeSalaryComponents",
//                 {
//                   employeeSalaryId,
//                   componentId: component.componentId,
//                   amount: component.amount,
//                   percentage: component.percentage,
//                   effectiveDate: component.effectiveDate,
//                   endDate: component.endDate,
//                   isActive: component.isActive,
//                   remarks: component.remarks,
//                 },
//                 false
//               )
//             )
//           })
//         )
//       }

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode("add");

//       showToast(isEdit ? "Employee salary updated successfully." : "Employee salary saved successfully.", "success");

//     } catch (error) {
//       console.error("Failed to save employee salary: ", error);

//       showToast(
//         error?.response?.data?.message ||
//         error?.response?.data?.Message ||
//         error?.message ||
//         "Failed to save employee salary.",
//         'error'
//       );
//     }
//   };

//   const handleUpdateComponent = async (component) => {
//     try {
//       await dispatch(
//         savePayrollEntity(
//           "employeeSalaryComponents",
//           component,
//           true
//         )
//       );

//       showToast("Salary component updated successfully.", "success");
//     } catch (error) {
//       console.error("Failed to update salary component: ", error);
//       showToast(
//         error?.response?.data?.Message ||
//         error?.response?.data?.message || 
//         error?.message || 
//         "Failed to update salary component.",
//         "error"
//       )

//       throw error;
//     }
//   }

//   const handleDelete = async (record) => {
//     const confirmed = await confirm({
//       title: "Delete this salary?",
//       message: `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`,
//       confirmLabel: "Delete",
//       cancelLabel: "Cancel",
//     })

//     if (!confirmed) {
//       return;
//     }

//     try {
//       await dispatch(
//         savePayrollEntity(
//           'employeeSalary',
//           {
//             id: record.id,
//             isActive: false,
//           },
//           true
//         )
//       );

//       setOpen(false);
//       setSelectedSalary(null);
//       setDialogMode('add');
//     } catch (err) {
//       console.error('Failed to delte employee salary: ', err);
//     }
//   }

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={["Payroll", "Employee Salary"]}
//         title="Employee Salary"
//         subtitle="Assign, revise and track individual employee salary records."
//       />

//       <Table
//         {...TABLE_PROPS}
//         title="Employee Salary"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={["empNo", "name", "department"]}
//         searchPlaceholder="Search by employee name or number..."
//         emptyMessage="No salary records found"
//         onAdd={{
//           label: "Assign Salary",
//           icon: <Plus {...ICON} />,
//           onClick: handleAdd,
//         }}
//         columns={[
//           { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
//           {
//             key: 'designation',
//             label: 'Designation',
//             className: 'text-gray-600',
//             render: (r) => {
//               const emp = employeeMap[r.empNo];
//               return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
//             },
//           },
//           { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
//           // { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.basic) },
//           // { key: 'workingDays', label: 'Working Days', align: 'right', className: 'text-gray-600' },
//           // { key: 'workingHours', label: 'Working Hours', align: 'right', className: 'text-gray-600' },
//           { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
//           { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
//           { key: 'effectiveEndDate', label: 'Effective End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           statusColumn,
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             render: (r) => (
//               <div className="flex items-center justify-center gap-2">
//                 <button
//                   type="button"
//                   onClick={() => handleView(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="View"
//                 >
//                   <Eye size={16} /> 
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleEdit(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-surface-100
//                     hover:text-primary-600
//                     transition-colors
//                   "
//                   title="Update"
//                 >
//                   <Pencil size={16} />
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleDelete(r)}
//                   className="
//                     inline-flex h-8 w-8 items-center justify-center
//                     rounded-md
//                     text-gray-500
//                     hover:bg-red-50
//                     hover:text-red-600
//                     transition-colors
//                   "
//                   title="Delete"
//                 >
//                   <Trash2 size={16} />
//                 </button> 
//               </div>
//             ),
//           },
//         ]}
//       />

//       <EmployeeSalaryDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         onSaveComponent={handleUpdateComponent}
//         employees={employees}
//         employeeSalaries={list}
//         salary={selectedSalary}
//         mode={dialogMode}
//         salaryComponents={components}
//         payrollComponents={payrollComponents}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </div>
//   );
// };

// export default PayrollEmployeeSalary;

// ------------------------------------------------------------------------------------------------------------------------

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Plus, Pencil, Eye, Trash2, Wallet, CheckCircle } from 'lucide-react';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Tabs from '../../../components/Tabs/Tabs';
import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';
import usePayrollEntity from '../../../utils/usePayrollEntity';
import { fmtMoney } from '../../../utils/payrollFormat';
import { toIsoDate } from '../../../utils/dateFormat';
import { fetchAllEmployees } from '../../../store/slices/employeeSlice';
import { getDesignationList } from '../../../store/slices/designationSlice';
import { savePayrollEntity } from '../../../store/slices/payrollSlice';
import EmployeeSalaryDialog from '../../../components/EmployeeSalary/EmployeeSalaryDialog';
import useToast from '../../../utils/useToast';
import Toast from '../../../components/Toast/Toast';
import { useConfirm } from '../../../utils/ConfirmContext';
import { getLoggedInServiceNo } from '../../../utils/masterDataUtils';

const ICON = { size: 15 }; 
const TABLE_PROPS = {
  search: true,
  searchLabel: 'Search',
  pageSize: 10,
  scrollClassName: '',
};

const statusColumn = {
  key: 'status',
  label: 'Status',
  align: 'center',
  render: (r) => <StatusPill label={r.status} />,
};

const approvalColumn = {
  key: 'approvalStatus',
  label: 'Approval',
  align: 'center',
  render: (r) => <StatusPill label={r.approvedBy ? "Approved" : "Pending"} variant={r.approvedBy ? "success" : "warning"} />,
};

/* ── Assign Salary Tab ───────────────────────────────────────────────────── */
const AssignSalaryTab = ({ list, loading, employees, components, payrollComponents, employeeMap, designationMap }) => {
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const { toast, showToast, hideToast } = useToast();

  const [open, setOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState("add");
  const [selectedSalary, setSelectedSalary] = useState(null);

  const handleAdd = () => {
    setSelectedSalary(null);
    setDialogMode("add");
    setOpen(true);
  };

  const handleView = (record) => {
    setSelectedSalary(record);
    setDialogMode("view");
    setOpen(true);
  };

  const handleEdit = (record) => {
    setSelectedSalary(record);
    setDialogMode("edit");
    setOpen(true);
  };

  const handleSave = async (form, pendingComponents = []) => {
    try {
      const isEdit = dialogMode === "edit";

      // Reverse "Monthly" / "Weekly" back to "M" / "W" for the database
      let rawFrequency = form.payFrequency;
      if (rawFrequency === "Monthly") rawFrequency = "M";
      if (rawFrequency === "Weekly") rawFrequency = "W";

      const payload = {
        ...form,
        payFrequency: rawFrequency,
        // approvedBy: isEdit ? (selectedSalary?.approvedBy || "") : "",
      };

      if (isEdit && selectedSalary?.approvedBy) {
        payload.approvedBy = selectedSalary.approvedBy;
      }

      const employeeSalaryId = await dispatch(
        savePayrollEntity("employeeSalary", payload, isEdit)
      );

      if (pendingComponents.length > 0) {
        await Promise.all(
          pendingComponents.map((component) => {
            dispatch(
              savePayrollEntity(
                "employeeSalaryComponents",
                {
                  employeeSalaryId,
                  componentId: component.componentId,
                  amount: component.amount,
                  percentage: component.percentage,
                  effectiveDate: component.effectiveDate,
                  endDate: component.endDate,
                  isActive: component.isActive,
                  remarks: component.remarks,
                },
                false
              )
            );
          })
        );
      }

      setOpen(false);
      setSelectedSalary(null);
      setDialogMode("add");
      showToast(isEdit ? "Employee salary updated successfully." : "Employee salary saved successfully. Pending Approval.", "success");
    } catch (error) {
      console.error("Failed to save employee salary: ", error);
      showToast(error?.response?.data?.Message || error?.message || "Failed to save employee salary.", 'error');
    }
  };

  const handleUpdateComponent = async (component) => {
    try {
      await dispatch(savePayrollEntity("employeeSalaryComponents", component, true));
      showToast("Salary component updated successfully.", "success");
    } catch (error) {
      showToast(error?.message || "Failed to update salary component.", "error");
      throw error;
    }
  };

  const handleDelete = async (record) => {
    const confirmed = await confirm({
      title: "Delete this salary?",
      message: `Are you sure you want to delete the salary record for ${record.name} (${record.empNo})`,
      confirmLabel: "Delete",
      cancelLabel: "Cancel",
    });

    if (!confirmed) return;

    try {
      await dispatch(savePayrollEntity('employeeSalary', { id: record.id, isActive: false }, true));
      setOpen(false);
      setSelectedSalary(null);
    } catch (err) {
      console.error('Failed to delete employee salary: ', err);
    }
  };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Assign Employee Salary"
        loading={loading}
        rows={list}
        rowKey="id"
        searchKeys={["empNo", "name"]}
        searchPlaceholder="Search by employee name or number..."
        emptyMessage="No salary records found"
        onAdd={{
          label: "Assign Salary",
          icon: <Plus {...ICON} />,
          onClick: handleAdd,
        }}
        columns={[
          { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
          { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
          {
            key: 'designation',
            label: 'Designation',
            className: 'text-gray-600',
            render: (r) => {
              const emp = employeeMap[r.empNo];
              return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
            },
          },
          { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
          { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.basic) },
          // { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
          { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
          approvalColumn,
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            render: (r) => (
              <div className="flex items-center justify-center gap-2">
                <button type="button" onClick={() => handleView(r)} className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-surface-100 hover:text-primary-600 transition-colors" title="View"><Eye size={16} /></button>
                <button type="button" onClick={() => handleEdit(r)} className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-surface-100 hover:text-primary-600 transition-colors" title="Update"><Pencil size={16} /></button>
                <button type="button" onClick={() => handleDelete(r)} className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-red-50 hover:text-red-600 transition-colors" title="Delete"><Trash2 size={16} /></button>
              </div>
            ),
          },
        ]}
      />
      <EmployeeSalaryDialog
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        onSaveComponent={handleUpdateComponent}
        employees={employees}
        employeeSalaries={list}
        salary={selectedSalary}
        mode={dialogMode}
        salaryComponents={components}
        payrollComponents={payrollComponents}
      />
      <Toast message={toast?.message} type={toast?.type} onClose={hideToast} />
    </>
  );
};

/* ── Approve Salary Tab ──────────────────────────────────────────────────── */
const ApproveSalaryTab = ({ list, loading, employeeMap, designationMap, employees, components, payrollComponents }) => {
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const { toast, showToast, hideToast } = useToast();

  const [open, setOpen] = useState(false);
  const [selectedSalary, setSelectedSalary] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isBulkApproving, setIsBulkApproving] = useState(false);

  // Filter for salaries that have NO approvedBy value
  const pendingSalaries = list.filter((r) => !r.approvedBy);

  // Check if all current pending salaries are selected
  const isAllSelected = pendingSalaries.length > 0 && selectedIds.length === pendingSalaries.length;

  const handleToggleAll = () => {
    if (isAllSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(pendingSalaries.map((r) => r.id))
    }
  };

  const handleToggleOne = (id) => {
    setSelectedIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  }

  const handleView = (record) => {
    setSelectedSalary(record);
    setOpen(true);
  }

  const handleApprove = async (record) => {
    const confirmed = await confirm({
      title: "Approve this salary?",
      message: `Are you sure you want to approve the salary record for ${record.name} (${record.empNo})?`,
      confirmLabel: "Approve",
      cancelLabel: "Cancel",
    });

    if (!confirmed) return;

    try {
      let rawFrequency = record.payFrequency;
      if (rawFrequency === "Monthly") rawFrequency = "M";
      if (rawFrequency === "Weekly") rawFrequency = "W";

      await dispatch(
        savePayrollEntity(
          'employeeSalary',
          {
            ...record,
            payFrequency: rawFrequency,
            approvedBy: getLoggedInServiceNo(),
          },
          true // Call update API
        )
      );
      showToast("Employee salary approved successfully.", "success");
    } catch (error) {
      console.error("Failed to approve salary: ", error);
      showToast(error?.message || "Failed to approve salary.", 'error');
    }
  };

  const handleBulkApprove = async () => {
    if (selectedIds.length === 0) return;

    const confirmed = await confirm({
      title: "Approve Selected Salaries?",
      message: `Are you sure you want to approve ${selectedIds.length} selected salary records?`,
      confirmLabel: "Approve All",
      cancelLabel: "Cancel",
    });

    if (!confirmed) return;

    setIsBulkApproving(true);
    try {
      const recordsToApprove = pendingSalaries.filter((r) => selectedIds.includes(r.id));

      await Promise.all(
        recordsToApprove.map((record) => {
          let rawFrequency = record.payFrequency;
          if (rawFrequency === "Monthly") rawFrequency = "M";
          if (rawFrequency === "Weekly") rawFrequency = "W";

          return dispatch(
            savePayrollEntity(
              'employeeSalary',
              {
                ...record,
                payFrequency: rawFrequency,
                approvedBy: getLoggedInServiceNo(),
              },
              true
            )
          )
        })
      )

      showToast(`Successfully approved ${recordsToApprove.length} salaries.`, 'success');
      setSelectedIds([]);
    } catch (error) {
      console.error("Failed to bulk approve salaries: ", error);
      showToast("Failed to approve some salaries.", "error");
    } finally {
      setIsBulkApproving(false);
    }
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Approve Employee Salary"
        loading={loading}
        rows={pendingSalaries}
        rowKey="id"
        searchKeys={["empNo", "name"]}
        searchPlaceholder="Search pending approvals..."
        emptyMessage="No salaries pending approval"
        toolbarExtra={
          selectedIds.length > 1 && (
            <button
              type="button"
              onClick={handleBulkApprove}
              disabled={isBulkApproving}
              className="inline-flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 disabled:opacity-50 transition-colors"
            >
              {isBulkApproving ? "Approving..." : `Approve Selected (${selectedIds.length})`}
            </button>
          )
        }
        columns={[
          {
            key: 'select',
            sortable: false,
            label: (
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleToggleAll}
                className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 cursor-pointer"
              />
            ),
            align: 'center',
            render: (r) => (
              <input
                type="checkbox"
                checked={selectedIds.includes(r.id)}
                onChange={() => handleToggleOne(r.id)}
                className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 cursor-pointer"
              />
            ),
          },
          { key: 'empNo', label: 'Staff Id', className: 'font-semibold text-gray-900' },
          { key: 'name', label: 'Employee', grow: true, className: 'text-gray-700' },
          {
            key: 'designation',
            label: 'Designation',
            className: 'text-gray-600',
            render: (r) => {
              const emp = employeeMap[r.empNo];
              return emp ? designationMap[emp.HED_DESIGNATION_ID] || '-' : '-';
            },
          },
          { key: 'payFrequency', label: 'Frequency', className: 'text-gray-600' },
          { key: 'basic', label: 'Basic Salary (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.basic) },
          // { key: 'dailyRate', label: 'Daily Rate (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.dailyRate) },
          { key: 'effectiveStartDate', label: 'Effective Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.effectiveDate) },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            render: (r) => (
              <div className='flex items-center justify-center gap-2'>
                <button
                  type='button'
                  onClick={() => handleView(r)}
                  className='inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-surface-100 hover:text-primary-600 transition-colors'
                  title='View'
                >
                  <Eye size={16} />
                </button>

                <button
                  type="button"
                  onClick={() => handleApprove(r)}
                  disabled={selectedIds.length > 1}
                  className="inline-flex items-center justify-center px-3 py-1.5 rounded-md text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Approve
                </button>
              </div>
            ),
          },
        ]}
      />

      <EmployeeSalaryDialog 
        open={open}
        onClose={() => setOpen(false)}
        onSave={() => {}} // Not needed in view mode
        onSaveComponent={() => {}} // Not needed in view mode
        employees={employees}
        employeeSalaries={list}
        salary={selectedSalary}
        mode="view"
        salaryComponents={components}
        payrollComponents={payrollComponents}
      />
      
      <Toast message={toast?.message} type={toast?.type} onClose={hideToast} />
    </>
  );
};

/* ── Page Wrapper ────────────────────────────────────────────────────────── */
const PayrollEmployeeSalary = () => {
  const dispatch = useDispatch();

  const employees = useSelector((state) => state.employees.employees);
  const designations = useSelector((state) => state.designationSlice.designations);

  const employeeMap = employees.reduce((map, emp) => {
    map[emp.HED_SERVICE_NO] = emp;
    return map;
  }, {});

  const designationMap = designations.reduce((map, designation) => {
    map[designation.HED_DESIGNATION_ID] = designation.HED_DESIGNATION_NAME;
    return map;
  }, {});

  const { list, loading } = usePayrollEntity("employeeSalary");
  const { list: components } = usePayrollEntity("employeeSalaryComponents");
  const { list: payrollComponents } = usePayrollEntity("payrollComponents");

  useEffect(() => {
    dispatch(fetchAllEmployees());
    dispatch(getDesignationList());
  }, [dispatch]);

  const tabs = [
    {
      key: 'assign',
      label: 'Assign Salary',
      icon: <Wallet {...ICON} />,
      content: <AssignSalaryTab list={list} loading={loading} employees={employees} components={components} payrollComponents={payrollComponents} employeeMap={employeeMap} designationMap={designationMap} />
    },
    {
      key: 'approval',
      label: 'Approve Salary',
      icon: <CheckCircle {...ICON} />,
      content: <ApproveSalaryTab list={list} loading={loading} employeeMap={employeeMap} designationMap={designationMap} employees={employees} components={components} payrollComponents={payrollComponents} />
    },
  ];

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={["Payroll", "Employee Salary"]}
        title="Employee Salary"
        subtitle="Assign, revise, and approve individual employee salary records."
      />
      <Tabs tabs={tabs} defaultTab="assign" />
    </div>
  );
};

export default PayrollEmployeeSalary;